export enum TrackEventsNames {
  LANDING = 'landing',
  POPUP = 'popup',
  CATALOGS_TO_ROADMAP_POPUP = 'catalogs_to_roadmap_popup',
  LIBRARY = 'library',
  SUBSCRIPTIONS = 'subscriptions',
  ACTIVATED_TRIAL_SUBSCRIPTION = 'ActivatedTrialSubscription',
  COURSE_VIEW = 'course_view',
  RECOMMENDATIONS = 'recommendations',
  PROFILE = 'profile',
  DETAILS = 'details',
  BOOKSHELF_DETAILS = 'bookshelf_details',
  COLLECTION_DETAILS = 'collection_details',
  SELECT_COURSE = 'select_course',
  STATISTICS_COMPARISON = 'statistics_comparison',
  BANNER = 'banner',
  MOTHER_TONGUE = 'mother_tongue',
  PASSWORD = 'password',
  BOOK_READER = 'book_reader',
  BOOK_READER_SETUP = 'book_reader_setup',
  BOOK_READER_WORD = 'book_reader_word',
  AUDIO_BOOK = 'audio_book',
  CONTEXT_TRANSLATION = 'context_translation',
  ROADMAP = 'roadmap',
  ROADMAP_TOPIC = 'roadmap_topic',
  LESSON_VIEW = 'lesson_view',
  LESSON_RESULTS = 'lesson_results',
  EXPLAIN_EXERCISE = 'explain_exercise',
  EXERCISE = 'exercise'
}

export enum TrackEventsTypes {
  FAQ = 'faq',
  TO_APP = 'to_app',
  OPEN_APP = 'open_app',
  COURSES = 'courses',
  ROADMAP = 'roadmap',
  APPEWA_MAIN = 'appewa_main'
}

export enum TrackEventsFaqSubtypes {
  VISITED = 'visited',
  SUPPORT_TAPPED = 'supportTapped',
  QUESTION_TAPPED = 'questionTapped',
  SOLVED_TAPPED = 'solvedTapped',
  BACK_TAPPED = 'backTapped',
  LINK_TAPPED = 'linkTapped'
}

export enum TrackEventsPopupSubtypes {
  CLOSED = 'closed',
  CLOSE_TAPPED = 'closeTapped',
  VISITED = 'visited',
  TAPPED = 'tapped',
  SHOWED = 'showed',
  OK_TAPPED = 'okTapped',
  QR_TAPPED = 'qrTapped'
}

export enum TrackEventsLandingSubtypes {
  APP_STORE_TAPPED = 'appStoreTapped',
  G_PLAY_TAPPED = 'gplayTapped',
  LETS_GO_TAPPED = 'letsGoTapped'
}

export enum TrackEventsLibrarySubtypes {
  VISITED = 'visited',
  LOADED = 'loaded',
  LOAD_ERROR = 'loadError',
  SEARCH_TAPPED = 'searchTapped',
  SEARCH_ENTERED = 'searchEntered',
  SEE_ALL_TAPPED = 'seeAllTapped',
  CONTENT_TAPPED = 'contentTapped'
}

export enum TrackEventsSubscriptionsSubtypes {
  ACTIVATED = 'activated'
}

export enum TrackNavigationType {
  DEFAULT = 'default',
  GOOGLE = 'google',
  APPLE = 'apple'
}

export enum TrackEventsAppewaMainSubtypes {
  ABOUT_TAPPED = 'aboutTapped',
  BLOG_TAPPED = 'blogTapped',
  AFFILIATE_TAPPED = 'affiliateTapped',
  PRESS_TAPPED = 'pressTapped',
  TERMS_TAPPED = 'termsTapped',
  PRIVACY_TAPPED = 'privacyTapped',
  PRICING_TAPPED = 'pricingTapped',
  B2B_TAPPED = 'b2bTapped',
  SUPPORT_TAPPED = 'supportTapped',
  APPSTORE_TAPPED = 'appStoreTapped',
  GOOGLEPLAY_TAPPED = 'gplayTapped',
  SOCIAL_TAPPED = 'socialTapped',
  ARTICLE_TAPPED = 'articleTapped',
  TOOLS_TAPPED = 'toolsTapped',
  SKILLS_TAPPED = 'skillsTapped',
  SIGN_IN_TAPPED = 'signInTapped',
  SIGN_UP_TAPPED = 'signUpTapped'
}

export enum TrackEventsCoursesSubtypes {
  LESSON_ICON_TAPPED = 'lessonIconTapped',
  VISITED = 'visited',
  SEE_ALL_TAPPED = 'seeAllTapped'
}

export enum TrackEventsProfileSubtypes {
  SUBSCRIPTIONS_VISITED = 'subscriptionsVisited',
  FREE_BUTTON_TAPPED = 'tryFreeButtonTapped',
  SUBSCRIPTION_CANCEL_TAPPED = 'subscriptionCancelTapped',
  CONTACT_SUPPORT_TAPPED = 'contactSupportTapped',
  SUPPORT_MESSAGE_SENT = 'support_message_sent'
}

export enum TrackEventsDetailsSubtypes {
  VISITED = 'visited',
  READ_TAPPED = 'readTapped',
  PLAY_TAPPED = 'playTapped',
  CLOSE_TAPPED = 'closeTapped'
}

export enum TrackEventsBookshelfSubtypes {
  VISITED = 'visited',
  CONTENT_TAPPED = 'contentTapped',
  CLOSE_TAPPED = 'closeTapped'
}

export enum TrackEventsCollectionSubtypes {
  VISITED = 'visited',
  CONTENT_TAPPED = 'contentTapped',
  CLOSE_TAPPED = 'closeTapped'
}

export enum TrackEventsSelectCourseSubtypes {
  VISITED = 'visited',
  UNIT_SELECTED = 'unitSelected'
}

export enum TrackEventsStatisticsComparisonSubtypes {
  SYNC_ROADMAP = 'sync_roadmap',
  MIGRATED_ROADMAP = 'migrated_roadmap'
}

export enum TrackEventsMotherTongueSubtypes {
  VISITED = 'visited',
  SUCCESS = 'success',
  ERROR = 'error'
}

export enum TrackEventsPasswordSubtypes {
  VISITED = 'visited',
  SUCCESS = 'success',
  UNKNOWN_ERROR = 'unknownError',
  SIGN_OUT = 'sign_out'
}

export enum TrackEventsBookReaderSubtypes {
  VISITED = 'visited',
  LOAD_ERROR = 'load_error',
  CLOSE_TAPPED = 'closeTapped',
  DID_READ_TO_END = 'didReadToEnd',
  SETUP_TAPPED = 'setupTapped',
  PROGRESS_READ = 'progressRead',
  INCREASE_RATE = 'increaseRate',
  DECREASE_RATE = 'decreaseRate'
}

export enum TrackEventsBookReaderSetupSubtypes {
  CHANGE_THEME = 'changeTheme',
  INCREASE_FONT = 'increaseFont',
  DECREASE_FONT = 'decreaseFont'
}

export enum TrackEventsAudioBookSubtypes {
  VISITED = 'visited',
  AUTO_PLAY = 'autoPlay',
  PLAY = 'play',
  DID_PLAY_TO_END = 'didPlayToEnd',
  PAUSE_BUTTON = 'pause_button',
  PLAY_ERROR = 'playError',
  PROGRESS_PLAY = 'progressPlay'
}

export enum TrackEventsBookReaderWordSubtypes {
  VISITED = 'visited',
  SPEAK_TAPPED = 'speakTapped'
}

export enum TrackEventsContextTranslationSubtypes {
  REQUEST = 'request',
  SUCCESS = 'success',
  ERROR = 'error',
  BUNDLE_REQUEST = 'bundleRequest',
  BUNDLE_SUCCESS = 'bundleSuccess'
}

export enum TrackEventsRoadmapSubtypes {
  VISITED = 'visited',
  LOADED = 'loaded',
  LOAD_ERROR = 'loadError',
  TOPIC_LESSON_TAPPED = 'topicLessonTapped'
}

export enum TrackEventsRoadmapTopicSubtypes {
  COURSE_LESSON_TAPPED = 'courseLessonTapped'
}

export enum TrackEventsLessonViewSubtypes {
  VISITED = 'visited',
  LOAD_ERROR = 'loadError',
  CLOSED = 'closed'
}

export enum TrackEventsLessonResultsSubtypes {
  VISITED = 'visited',
  SENT = 'sent',
  LEARN_TAPPED = 'learnTapped',
  BACK_TAPPED = 'backTapped'
}

export enum TrackEventsExplainExerciseSubtypes {
  VISITED = 'visited',
  PLAY_TAPPED = 'playTapped',
  PLAY_SLOW_TAPPED = 'playSlowTapped',
  NEXT_TAPPED = 'nextTapped'
}

export enum TrackEventsExerciseSubtypes {
  VISITED = 'visited',
  RIGHT_ANSWER = 'rightAnswer',
  WRONG_ANSWER = 'wrongAnswer',
  HINT_TAPPED = 'hintTapped',
  PLAY_TAPPED = 'playTapped',
  PLAY_SLOW_TAPPED = 'playSlowTapped',
  CHECK_TAPPED = 'checkTapped',
  ERROR = 'error'
}
